import { ChangeEvent } from 'react';

import { z } from 'zod';

import { ValueEditorInputProps } from './useValueEditor';

interface UseTextEditorReturnProps {
  type: string;
  getTextEditorValue: (i?: number) => string | undefined;
  handleTextEditorValueChange: (i?: number) => (event: ChangeEvent<HTMLInputElement>) => void;
}

export const useTextEditor = ({
  field,
  values,
  handleSingleValue,
  handleMultipleValues,
}: ValueEditorInputProps): UseTextEditorReturnProps => {
  return {
    type: field.inputType || 'text',
    getTextEditorValue: (i = 0) => {
      return z.coerce.string().optional().catch('').parse(values?.[i]);
    },
    handleTextEditorValueChange: (i) => {
      if (i === undefined) {
        return ({ target: { value } }) => handleSingleValue(value);
      }

      return ({ target: { value } }) => handleMultipleValues(value, i);
    },
  };
};
